// src/components/footer/footer.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment FooterButtonFragment on FooterButton {\n    __typename\n    type\n    url\n    text\n    trackingEvent\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment FooterSeparatorFragment on FooterSeparator {\n    __typename\n    separatorType: type\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment FooterSectionButtonsFragment on FooterSectionButtons {\n    __typename\n    data {\n      ... on FooterButton {\n        __typename\n        type\n        url\n        text\n        trackingEvent\n      }\n      ... on FooterSeparator {\n        __typename\n        separatorType: type\n      }\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment FooterSectionCobrandFragment on FooterSectionCobrand {\n    __typename\n    data {\n      ... on FooterCobrandLogo {\n        text\n        mark {\n          url {\n            value\n          }\n          description\n        }\n      }\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment FooterSectionImagesFragment on FooterSectionImages {\n    __typename\n    data {\n      ... on FooterImage {\n        imgSrc\n        url\n        target\n        newWindowText\n        altText\n      }\n    }\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment FooterSectionLinksFragment on FooterSectionLinks {\n    __typename\n    data {\n      ... on FooterLink {\n        url\n        text\n        trackingEvent\n        target\n      }\n    }\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment FooterSectionTextFragment on FooterSectionText {\n    __typename\n    data {\n      ... on FooterText {\n        text\n      }\n    }\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment NorthstarFooterSectionImagesFragment on NorthstarFooterSectionImages {\n    __typename\n    data {\n      ... on NorthstarFooterImage {\n        imgSrc\n        url\n        altText\n        target\n        newWindowText\n      }\n    }\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment NorthstarFooterMinimalLinksFragment on NorthstarMinimalFooterSectionLinks {\n    __typename\n    data {\n      ...NorthstarFooterMinimalImageFragment\n      ...NorthstarFooterMinimalLinkFragment\n    }\n  }\n  fragment NorthstarFooterMinimalImageFragment on NorthstarFooterImage {\n    imgSrc\n    url\n    altText\n    target\n    __typename\n  }\n  fragment NorthstarFooterMinimalLinkFragment on FooterLink {\n    target\n    text\n    trackingEvent\n    url\n    __typename\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment NorthstarFooterSectionLinksFragment on NorthstarFooterSectionLinks {\n    __typename\n    data {\n      ...NorthstarFooterImageFragment\n      ...NorthstarFooterSectionFragment\n    }\n    minimal\n  }\n  fragment NorthstarFooterImageFragment on NorthstarFooterImage {\n    imgSrc\n    url\n    altText\n    target\n    __typename\n    newWindowText\n  }\n  fragment NorthstarFooterSectionFragment on NorthstarFooterSection {\n    text\n    __typename\n    data {\n      ... on NorthstarFooterSectionLink {\n        target\n        text\n        trackingEvent\n        url\n        __typename\n      }\n    }\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment NorthstarFooterSectionTextFragment on NorthstarFooterSectionText {\n    __typename\n    data {\n      ... on NorthstarFooterText {\n        text\n      }\n    }\n    minimal\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  query FooterQuery($context: ContextInput!, $minimal: Boolean) {\n    globalFooter(context: $context, minimal: $minimal) {\n      footerHeadingLabel\n      sectionData {\n        __typename\n        ...FooterSectionButtonsFragment\n        ...FooterSectionCobrandFragment\n        ...FooterSectionLinksFragment\n        ...FooterSectionTextFragment\n        ...FooterSectionImagesFragment\n        ...NorthstarFooterSectionLinksFragment\n        ...NorthstarFooterSectionTextFragment\n        ...NorthstarFooterSectionImagesFragment\n        ...NorthstarFooterMinimalLinksFragment\n      }\n      minimal\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
import React12 from "react";
import { gql as gql12, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { GlobalNavigationSiteFooter } from "uitk-react-global-navigation";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
// src/components/footer/__private/__fragments/footer-section-buttons.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem } from "uitk-react-layout-flex";
// src/components/footer/__private/__fragments/footer-button.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var FooterButton = function (props) {
  var data = props.data,
    analyticsCallback = props.analyticsCallback;
  var type = data.type,
    url = data.url,
    text = data.text,
    trackingEvent = data.trackingEvent;
  if (!text) {
    return null;
  }
  var buttonProps = {
    href: url
  };
  if (trackingEvent && analyticsCallback) {
    buttonProps.onClickCapture = function () {
      return analyticsCallback(trackingEvent, text);
    };
  }
  return /* @__PURE__ */React.createElement(UitkLayoutFlex, {
    justifyContent: "center"
  }, type === "PRIMARY" && /* @__PURE__ */React.createElement(UitkPrimaryButton, _object_spread({}, buttonProps), /* @__PURE__ */React.createElement(UitkText, {
    size: 300
  }, text)), type === "SECONDARY" && /* @__PURE__ */React.createElement(UitkSecondaryButton, _object_spread({}, buttonProps), /* @__PURE__ */React.createElement(UitkText, {
    size: 300
  }, text)), type === "TERTIARY" && /* @__PURE__ */React.createElement(UitkTertiaryButton, _object_spread({}, buttonProps), /* @__PURE__ */React.createElement(UitkText, {
    size: 300
  }, text)));
};
FooterButton.displayName = "FooterButton";
FooterButton.fragment = fragment;
FooterButton.fragment.__typename = "FooterButton";
// src/components/footer/__private/__fragments/footer-separator.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
var fragment2 = gql2(_templateObject1());
var FooterSeparator = function (props) {
  var separatorType = props.data.separatorType;
  return /* @__PURE__ */React2.createElement(React2.Fragment, null, separatorType === "HORIZONTAL_RULE" && /* @__PURE__ */React2.createElement("hr", null));
};
FooterSeparator.displayName = "FooterSeparator";
FooterSeparator.fragment = fragment2;
FooterSeparator.fragment.__typename = "FooterSeparator";
// src/components/footer/__private/__fragments/footer-section-buttons.tsx
var fragment3 = gql3(_templateObject2());
var ButtonSectionComponents = [FooterButton, FooterSeparator];
var FooterSectionButtons = function (props) {
  var data = props.data,
    analyticsCallback = props.analyticsCallback;
  var sectionData = data.data;
  return /* @__PURE__ */React3.createElement(UitkLayoutFlex2, {
    direction: "column",
    tag: "ul",
    className: "no-bullet"
  }, sectionData.map(function (item, index) {
    if (!item) {
      return null;
    }
    var Component = ButtonSectionComponents.find(function (component) {
      var _item;
      return component.fragment.__typename === ((_item = item) === null || _item === void 0 ? void 0 : _item.__typename);
    });
    if (!Component) {
      return null;
    }
    return /* @__PURE__ */React3.createElement(UitkLayoutFlexItem, {
      key: "".concat(index, "-").concat(item.__typename),
      minWidth: "full_width"
    }, /* @__PURE__ */React3.createElement("li", null, /* @__PURE__ */React3.createElement(Component, {
      data: item,
      analyticsCallback: analyticsCallback
    })));
  }));
};
FooterSectionButtons.displayName = "FooterSectionButtons";
FooterSectionButtons.fragment = fragment3;
FooterSectionButtons.fragment.__typename = "FooterSectionButtons";
// src/components/footer/__private/__fragments/footer-section-cobrand.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment4 = gql4(_templateObject3());
var FooterSectionCobrand = function (props) {
  var data = props.data;
  var sectionData = data.data;
  return /* @__PURE__ */React4.createElement(UitkSpacing, {
    padding: {
      block: "three"
    }
  }, /* @__PURE__ */React4.createElement(UitkLayoutFlex3, {
    direction: "row",
    alignItems: "start",
    justifyContent: "start"
  }, sectionData.map(function (cobrand) {
    var _cobrand, _cobrand_mark_url, _cobrand1;
    if (((_cobrand = cobrand) === null || _cobrand === void 0 ? void 0 : _cobrand.text) && ((_cobrand1 = cobrand) === null || _cobrand1 === void 0 ? void 0 : (_cobrand_mark_url = _cobrand1.mark.url) === null || _cobrand_mark_url === void 0 ? void 0 : _cobrand_mark_url.value)) {
      var _cobrand_mark_url1, _cobrand2, _cobrand_mark_url2, _cobrand3, _cobrand4;
      return /* @__PURE__ */React4.createElement(UitkLayoutFlexItem2, {
        key: (_cobrand2 = cobrand) === null || _cobrand2 === void 0 ? void 0 : (_cobrand_mark_url1 = _cobrand2.mark.url) === null || _cobrand_mark_url1 === void 0 ? void 0 : _cobrand_mark_url1.value
      }, /* @__PURE__ */React4.createElement(UitkLayoutFlex3, {
        direction: "row",
        alignItems: "center",
        justifyContent: "center",
        space: "one"
      }, /* @__PURE__ */React4.createElement(UitkText2, null, cobrand.text), /* @__PURE__ */React4.createElement(UitkMark, {
        url: (_cobrand3 = cobrand) === null || _cobrand3 === void 0 ? void 0 : (_cobrand_mark_url2 = _cobrand3.mark.url) === null || _cobrand_mark_url2 === void 0 ? void 0 : _cobrand_mark_url2.value,
        description: (_cobrand4 = cobrand) === null || _cobrand4 === void 0 ? void 0 : _cobrand4.mark.description,
        size: UitkMarkSize.MEDIUM
      })));
    }
    return null;
  })));
};
FooterSectionCobrand.displayName = "FooterSectionCobrand";
FooterSectionCobrand.fragment = fragment4;
FooterSectionCobrand.fragment.__typename = "FooterSectionCobrand";
// src/components/footer/__private/__fragments/footer-section-images.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var fragment5 = gql5(_templateObject4());
var FooterSectionImages = function (props) {
  var data = props.data;
  var sectionData = data.data;
  return /* @__PURE__ */React5.createElement(UitkSpacing2, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React5.createElement(UitkLayoutFlex4, {
    direction: "row",
    alignItems: "center",
    justifyContent: "center"
  }, sectionData.map(function (image, index) {
    var _image;
    var isBlankTarget = ((_image = image) === null || _image === void 0 ? void 0 : _image.target) === "_blank";
    if (!image || !image.imgSrc) {
      return null;
    }
    return /* @__PURE__ */React5.createElement(UitkSpacing2, {
      padding: {
        inline: "two"
      },
      key: index
    }, /* @__PURE__ */React5.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React5.createElement("a", {
      href: image.url,
      target: image.target || void 0,
      rel: isBlankTarget ? "noopener" : void 0
    }, /* @__PURE__ */React5.createElement("img", {
      "aria-label": isBlankTarget && image.newWindowText ? image.newWindowText : void 0,
      src: image.imgSrc,
      alt: image.altText || void 0
    }))));
  })));
};
FooterSectionImages.displayName = "FooterSectionImages";
FooterSectionImages.fragment = fragment5;
FooterSectionImages.fragment.__typename = "FooterSectionImages";
// src/components/footer/__private/__fragments/footer-section-links.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var fragment6 = gql6(_templateObject5());
var FooterSectionLinks = function (props) {
  var data = props.data,
    analyticsCallback = props.analyticsCallback;
  var sectionData = data.data;
  var clickTracker = function (rfrrId, linkName) {
    if (rfrrId && analyticsCallback) {
      analyticsCallback(rfrrId, linkName);
    }
  };
  return /* @__PURE__ */React6.createElement(UitkLayoutFlex5, {
    className: "no-bullet",
    direction: "row",
    alignItems: "center",
    justifyContent: "center",
    wrap: "wrap",
    tag: "ul"
  }, sectionData.map(function (link, index) {
    if (!link || !link.url) {
      return null;
    }
    return /* @__PURE__ */React6.createElement(UitkSpacing3, {
      padding: {
        inlineend: "three"
      },
      key: index
    }, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem4, {
      className: "global-navigation-footer-navlink"
    }, /* @__PURE__ */React6.createElement("li", null, /* @__PURE__ */React6.createElement(UitkLink, {
      size: "small",
      theme: "default",
      onClickCapture: function () {
        return clickTracker(link.trackingEvent, "footer link item");
      }
    }, /* @__PURE__ */React6.createElement("a", {
      target: link.target || void 0,
      href: link.url
    }, link.text)))));
  }));
};
FooterSectionLinks.displayName = "FooterSectionLinks";
FooterSectionLinks.fragment = fragment6;
FooterSectionLinks.fragment.__typename = "FooterSectionLinks";
// src/components/footer/__private/__fragments/footer-section-text.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment7 = gql7(_templateObject6());
var FooterSectionText = function (props) {
  var data = props.data;
  var sectionData = data.data;
  return /* @__PURE__ */React7.createElement(UitkSpacing4, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React7.createElement(UitkLayoutFlex6, {
    className: "no-bullet",
    direction: "column",
    alignItems: "center",
    wrap: "wrap",
    tag: "ul"
  }, sectionData.map(function (item, index) {
    if (!item || !item.text) {
      return null;
    }
    return /* @__PURE__ */React7.createElement(UitkLayoutFlexItem5, {
      key: index,
      className: "global-navigation-footer-text"
    }, /* @__PURE__ */React7.createElement("li", null, /* @__PURE__ */React7.createElement(UitkText3, {
      weight: "regular",
      align: "center",
      overflow: "wrap",
      size: 200,
      spacing: "two"
    }, item.text)));
  })));
};
FooterSectionText.displayName = "FooterSectionText";
FooterSectionText.fragment = fragment7;
FooterSectionText.fragment.__typename = "FooterSectionText";
// src/components/footer/__private/__fragments/northstar-footer/northstar-footer-section-images.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
var fragment8 = gql8(_templateObject7());
var NorthstarFooterSectionImages = function (props) {
  var data = props.data;
  var sectionData = data.data;
  if (sectionData.length === 0) {
    return null;
  }
  return /* @__PURE__ */React8.createElement(UitkLayoutFlex7, {
    className: "no-bullet",
    direction: "row",
    alignItems: "center",
    justifyContent: "start",
    wrap: "wrap",
    tag: "ul"
  }, sectionData.map(function (image, index) {
    var _image;
    var isBlankTarget = ((_image = image) === null || _image === void 0 ? void 0 : _image.target) === "_blank";
    if (!image || !image.imgSrc) {
      return null;
    }
    return /* @__PURE__ */React8.createElement(UitkSpacing5, {
      key: index,
      padding: {
        block: "three",
        inlineend: "two"
      }
    }, /* @__PURE__ */React8.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */React8.createElement("li", null, /* @__PURE__ */React8.createElement("a", {
      href: image.url,
      target: image.target || void 0,
      rel: image.target === "_blank" ? "noopener" : void 0
    }, /* @__PURE__ */React8.createElement("img", {
      "aria-label": isBlankTarget && image.newWindowText ? image.newWindowText : void 0,
      src: image.imgSrc,
      alt: image.altText || void 0,
      width: "100%",
      loading: "lazy"
    })))));
  }));
};
NorthstarFooterSectionImages.displayName = "NorthstarFooterSectionImages";
NorthstarFooterSectionImages.fragment = fragment8;
NorthstarFooterSectionImages.fragment.__typename = "NorthstarFooterSectionImages";
// src/components/footer/__private/__fragments/northstar-footer/northstar-footer-minimal-links.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing6, UitkSpacingHr } from "uitk-react-spacing";
var fragment9 = gql9(_templateObject8());
var NorthstarMinimalFooterSectionLinks = function (props) {
  var _sectionData_;
  var data = props.data;
  var sectionData = data.data;
  var sectionsLength = sectionData.length;
  var clickTracker = useClickTracker();
  if (sectionsLength === 0) {
    return null;
  }
  if (sectionsLength === 1 && ((_sectionData_ = sectionData[0]) === null || _sectionData_ === void 0 ? void 0 : _sectionData_.__typename) === "NorthstarFooterImage") {
    return /* @__PURE__ */React9.createElement(UitkLayoutFlex8, {
      className: "no-bullet",
      direction: "column",
      alignItems: "center",
      justifyContent: "center",
      tag: "ul"
    }, /* @__PURE__ */React9.createElement("a", {
      key: 1,
      href: sectionData[0].url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /* @__PURE__ */React9.createElement("img", {
      src: sectionData[0].imgSrc,
      alt: sectionData[0].altText || void 0,
      width: "100%",
      loading: "lazy"
    })));
  }
  var copyrightImageSection = function (section, index) {
    return /* @__PURE__ */React9.createElement(UitkLayoutGridItem, {
      key: index,
      colStart: {
        large: 1
      },
      rowStart: {
        large: 1
      },
      colSpan: 2
    }, /* @__PURE__ */React9.createElement(UitkSpacing6, {
      padding: {
        blockend: "two"
      }
    }, /* @__PURE__ */React9.createElement(UitkLayoutFlex8, {
      className: "no-bullet",
      direction: "column",
      alignItems: "start",
      justifyContent: "start",
      tag: "ul"
    }, /* @__PURE__ */React9.createElement("a", {
      key: index,
      href: section.url,
      target: section.target || void 0,
      rel: section.target === "_blank" ? "noopener" : void 0
    }, /* @__PURE__ */React9.createElement("img", {
      src: section.imgSrc,
      alt: section.altText || void 0,
      width: "100%",
      loading: "lazy"
    })))));
  };
  var footerLinksSection = function (link, index) {
    return /* @__PURE__ */React9.createElement(UitkLayoutFlex8, {
      justifyContent: "start"
    }, /* @__PURE__ */React9.createElement(UitkLink2, {
      key: index,
      size: "small",
      theme: "default",
      inline: true,
      onClickCapture: function () {
        return clickTracker(link.trackingEvent || "", "footer link item");
      }
    }, /* @__PURE__ */React9.createElement("a", {
      target: link.trackingEvent || void 0,
      href: link.url
    }, link.text)));
  };
  return /* @__PURE__ */React9.createElement(React9.Fragment, null, /* @__PURE__ */React9.createElement(UitkSpacing6, {
    padding: "three"
  }, /* @__PURE__ */React9.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */React9.createElement(UitkLayoutGrid, {
    className: "no-bullet uitk-layout-grid-columns-large-5",
    columns: {
      small: 2,
      medium: 4
    },
    rows: {
      small: 3,
      medium: 2,
      large: 1,
      auto_fit: "zero"
    },
    space: "three",
    alignItems: "start",
    justifyContent: "center",
    tag: "ul"
  }, sectionsLength > 1 && sectionData.map(function (section, index) {
    if (section.__typename === "NorthstarFooterImage") {
      return copyrightImageSection(section, index);
    }
    return /* @__PURE__ */React9.createElement(UitkLayoutGridItem, {
      rowStart: {
        medium: 2,
        large: 1
      },
      alignSelf: "start",
      key: index
    }, footerLinksSection(section, index));
  })))), sectionsLength > 1 && /* @__PURE__ */React9.createElement("div", null, /* @__PURE__ */React9.createElement(UitkSpacingHr, {
    blockMargin: "six"
  })));
};
NorthstarMinimalFooterSectionLinks.displayName = "NorthstarMinimalFooterSectionLinks";
NorthstarMinimalFooterSectionLinks.fragment = fragment9;
NorthstarMinimalFooterSectionLinks.fragment.__typename = "NorthstarMinimalFooterSectionLinks";
// src/components/footer/__private/__fragments/northstar-footer/northstar-footer-section-links.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing as UitkSpacing7, UitkSpacingHr as UitkSpacingHr2 } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
var fragment10 = gql10(_templateObject9());
var NorthstarFooterSectionLinks = function (props) {
  var _sectionData_;
  var data = props.data;
  var sectionData = data.data;
  var sectionsLength = sectionData.length;
  var clickTracker = useClickTracker2();
  if (sectionsLength === 0) {
    return null;
  }
  if (sectionsLength === 1 && ((_sectionData_ = sectionData[0]) === null || _sectionData_ === void 0 ? void 0 : _sectionData_.__typename) === "NorthstarFooterImage") {
    return /* @__PURE__ */React10.createElement(UitkLayoutFlex9, {
      className: "no-bullet",
      direction: "column",
      alignItems: "center",
      justifyContent: "center",
      tag: "ul"
    }, /* @__PURE__ */React10.createElement("a", {
      key: 1,
      href: sectionData[0].url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /* @__PURE__ */React10.createElement("img", {
      src: sectionData[0].imgSrc,
      alt: sectionData[0].altText || void 0,
      width: "100%",
      loading: "lazy"
    })));
  }
  var copyrightImageSection = function (section, index) {
    var _section;
    var isBlankTarget = ((_section = section) === null || _section === void 0 ? void 0 : _section.target) === "_blank";
    if (!section || !section.imgSrc) {
      return null;
    }
    return /* @__PURE__ */React10.createElement(UitkLayoutGridItem2, {
      key: index,
      colStart: {
        large: 1
      },
      rowStart: {
        large: 1
      },
      colSpan: 2
    }, /* @__PURE__ */React10.createElement(UitkListItem, null, /* @__PURE__ */React10.createElement(UitkSpacing7, {
      padding: {
        blockstart: "two"
      }
    }, /* @__PURE__ */React10.createElement(UitkLayoutFlex9, {
      className: "no-bullet",
      direction: "column",
      alignItems: "start",
      justifyContent: "start"
    }, /* @__PURE__ */React10.createElement("a", {
      href: section.url,
      target: section.target || void 0
    }, /* @__PURE__ */React10.createElement("img", {
      "aria-label": isBlankTarget && section.newWindowText ? section.newWindowText : void 0,
      src: section.imgSrc,
      alt: section.altText || void 0,
      width: "100%",
      loading: "lazy"
    }))))));
  };
  var footerSubSections = function (section) {
    if (section === null || section.data === null) {
      return null;
    }
    if (section.data.length > 0) {
      var _section;
      return /* @__PURE__ */React10.createElement(UitkListItem, null, /* @__PURE__ */React10.createElement(UitkSpacing7, {
        padding: {
          blockstart: "two"
        }
      }, /* @__PURE__ */React10.createElement(UitkHeading, {
        tag: "h3",
        size: 7
      }, (_section = section) === null || _section === void 0 ? void 0 : _section.text)), /* @__PURE__ */React10.createElement(UitkList, {
        type: "unordered",
        bullet: "no-bullet"
      }, section.data.map(function (link, id) {
        var _link_text;
        return /* @__PURE__ */React10.createElement(UitkSpacing7, {
          key: id,
          padding: {
            blockstart: "two"
          }
        }, /* @__PURE__ */React10.createElement(UitkListItem, null, /* @__PURE__ */React10.createElement(UitkLayoutFlex9, null, /* @__PURE__ */React10.createElement(UitkLink3, {
          size: "small",
          theme: "default",
          onClickCapture: function () {
            return clickTracker(link.trackingEvent || "", "footer link item");
          }
        }, /* @__PURE__ */React10.createElement("a", {
          "aria-label": (_link_text = link.text) !== null && _link_text !== void 0 ? _link_text : void 0,
          href: link.url,
          target: link.target || void 0
        }, link.text)))));
      })));
    }
    return null;
  };
  return /* @__PURE__ */React10.createElement(React10.Fragment, null, /* @__PURE__ */React10.createElement(UitkLayoutFlexItem8, {
    minWidth: "full_width"
  }, /* @__PURE__ */React10.createElement(UitkSpacing7, {
    padding: {
      blockend: "two"
    }
  }, /* @__PURE__ */React10.createElement(UitkList, {
    spacing: false,
    type: "unordered",
    bullet: "no-bullet"
  }, sectionsLength > 0 && sectionData.map(function (section, index) {
    var _section;
    if (((_section = section) === null || _section === void 0 ? void 0 : _section.__typename) === "NorthstarFooterImage") {
      return copyrightImageSection(section, index);
    }
    return /* @__PURE__ */React10.createElement(UitkLayoutGridItem2, {
      key: index,
      rowStart: {
        medium: 2,
        large: 2
      },
      alignSelf: "start"
    }, footerSubSections(section));
  })))), sectionsLength > 0 && /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(UitkSpacingHr2, {
    blockMargin: "six"
  })));
};
NorthstarFooterSectionLinks.displayName = "NorthstarFooterSectionLinks";
NorthstarFooterSectionLinks.fragment = fragment10;
NorthstarFooterSectionLinks.fragment.__typename = "NorthstarFooterSectionLinks";
// src/components/footer/__private/__fragments/northstar-footer/northstar-footer-section-text.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkListItem as UitkListItem2 } from "uitk-react-list";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment11 = gql11(_templateObject10());
var NorthstarFooterSectionText = function (props) {
  var data = props.data;
  var sectionData = data.data;
  if (sectionData.length === 0) {
    return null;
  }
  return /* @__PURE__ */React11.createElement(UitkLayoutFlex10, {
    className: "no-bullet",
    direction: "column",
    alignItems: "center",
    wrap: "wrap",
    tag: "ul"
  }, sectionData.map(function (item, index) {
    if (!item || !item.text) {
      return null;
    }
    return /* @__PURE__ */React11.createElement(UitkLayoutFlexItem9, {
      key: index,
      minWidth: "full_width",
      alignSelf: "start"
    }, /* @__PURE__ */React11.createElement(UitkListItem2, null, /* @__PURE__ */React11.createElement(UitkText4, {
      weight: "regular",
      align: "left",
      overflow: "wrap",
      size: 200
    }, /* @__PURE__ */React11.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.text
      }
    }))));
  }));
};
NorthstarFooterSectionText.displayName = "NorthstarFooterSectionText";
NorthstarFooterSectionText.fragment = fragment11;
NorthstarFooterSectionText.fragment.__typename = "NorthstarFooterSectionText";
// src/components/footer/footer.tsx
var __FooterQuery = gql12(_templateObject11(), FooterSectionButtons.fragment, FooterSectionCobrand.fragment, FooterSectionLinks.fragment, FooterSectionText.fragment, FooterSectionImages.fragment, NorthstarFooterSectionLinks.fragment, NorthstarFooterSectionText.fragment, NorthstarFooterSectionImages.fragment, NorthstarMinimalFooterSectionLinks.fragment);
var sectionTypes = [NorthstarFooterSectionLinks, NorthstarFooterSectionText, NorthstarFooterSectionImages, NorthstarMinimalFooterSectionLinks, FooterSectionButtons, FooterSectionCobrand, FooterSectionLinks, FooterSectionText, FooterSectionImages];
var Footer = function (props) {
  var _data;
  var minimal = props.minimal,
    skipSsr = props.skipSsr,
    analyticsCallback = props.analyticsCallback;
  var context = useBexApi().context;
  var variables = {
    context: context,
    minimal: minimal
  };
  var _useQuery = useQuery(__FooterQuery, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !((_data = data) === null || _data === void 0 ? void 0 : _data.globalFooter)) {
    return null;
  }
  var globalFooter = data.globalFooter;
  return /* @__PURE__ */React12.createElement(React12.Fragment, null, globalFooter.footerHeadingLabel && /* @__PURE__ */React12.createElement(UitkHeading2, {
    tag: "h2",
    className: "is-visually-hidden",
    size: 4
  }, globalFooter.footerHeadingLabel), Array.isArray(globalFooter.sectionData) && globalFooter.sectionData.length > 0 && /* @__PURE__ */React12.createElement(GlobalNavigationSiteFooter, null, /* @__PURE__ */React12.createElement(UitkSpacing8, {
    padding: {
      inlinestart: "six",
      blockstart: "six",
      blockend: "twelve",
      small: {
        inlineend: "three"
      },
      medium: {
        inlineend: "three"
      },
      large: {
        inlineend: "two"
      },
      extra_large: {
        inlineend: "two"
      }
    },
    margin: "unset"
  }, /* @__PURE__ */React12.createElement(UitkLayoutFlex11, {
    direction: "column"
  }, globalFooter.sectionData.map(function (sectionData, index) {
    if (!sectionData) {
      return null;
    }
    var Section = sectionTypes.find(function (type) {
      return type.fragment.__typename === sectionData.__typename;
    });
    if (!Section) {
      return null;
    }
    return /* @__PURE__ */React12.createElement(UitkLayoutFlexItem10, {
      key: index
    }, /* @__PURE__ */React12.createElement(Section, {
      key: index,
      data: sectionData,
      minimal: globalFooter.minimal,
      analyticsCallback: analyticsCallback
    }));
  })))));
};
Footer.displayName = "sharedui-Footer";
export { Footer };